import { memo } from "react";

import { QuestionPlanCheckInAvailableDayOfTheWeek } from "@/components/features/items/edit/plan/_shared/ui/components/term/check-in-available-day-of-the-week";

import { useDayTripPlanCheckInAvailableDayOfTheWeek } from "./hooks/use-check-in-available-day-of-the-week";

export const QuestionDayTripPlanCheckInAvailableDayOfTheWeek = memo(() => {
	const {
		checkInAvailableDayOfTheWeek,
		rawCheckInAvailableDayOfTheWeek,
		onSetCheckInAvailableDayOfTheWeek,
		isHolidayCheckInAvailable,
		onSetIsHolidayCheckInAvailable,
	} = useDayTripPlanCheckInAvailableDayOfTheWeek();

	return (
		<QuestionPlanCheckInAvailableDayOfTheWeek
			checkInAvailableDayOfTheWeek={checkInAvailableDayOfTheWeek}
			rawCheckInAvailableDayOfTheWeek={rawCheckInAvailableDayOfTheWeek}
			onSetCheckInAvailableDayOfTheWeek={onSetCheckInAvailableDayOfTheWeek}
			isHolidayCheckInAvailable={isHolidayCheckInAvailable}
			onSetIsHolidayCheckInAvailable={onSetIsHolidayCheckInAvailable}
		/>
	);
});

QuestionDayTripPlanCheckInAvailableDayOfTheWeek.displayName = "QuestionDayTripPlanCheckInAvailableDayOfTheWeek";
